/**
 * Home's "everything you owe" (R2 batch B item 2). The API's feed sends `owed`
 * (TimelineOwedItem): Due entry fees, Bill to requests waiting for an answer, and
 * failed or retrying charges, each with its reason already written. This file
 * only decides each row's action. Pure; mirrored by the app's owed_items.dart.
 */

export const OwedKind = Object.freeze({
    EntryFee: 'entryFee',
    BillToRequest: 'billToRequest',
    FailedCharge: 'failedCharge',
});

/**
 * The rows to show. An API that predates `owed` sends only outstandingCharges
 * (failed or retrying charges), which become failed-charge rows as before.
 */
export const owedRows = (owed, outstandingCharges) => {
    if (owed?.length) return owed;
    return (outstandingCharges ?? []).map((c) => ({
        kind: OwedKind.FailedCharge,
        id: c.chargeId,
        clubName: c.clubName,
        amountMinor: c.amountMinor,
        currency: c.currency,
        reason: `Your card couldn't be charged. Paid RSVPs at ${c.clubName} are paused until this is settled.`,
        pausesPaidRsvps: true,
    }));
};

export const owedActionLabel = (item) => ({
    [OwedKind.EntryFee]: 'Pay',
    [OwedKind.BillToRequest]: 'Review',
    [OwedKind.FailedCharge]: 'Fix card',
})[item?.kind] ?? 'View';

export const owedIcon = (item) => ({
    [OwedKind.EntryFee]: 'mdi-credit-card-clock-outline',
    [OwedKind.BillToRequest]: 'mdi-account-cash-outline',
    [OwedKind.FailedCharge]: 'mdi-credit-card-off-outline',
})[item?.kind] ?? 'mdi-credit-card-outline';

/**
 * What the row's button does: open the pay dialog for that fee, or go to the
 * page that settles it (the Bill to request, or the payments tab for a card).
 */
export const owedAction = (item) => {
    if (item?.kind === OwedKind.EntryFee) return {type: 'pay', obligationId: item.id};
    if (item?.kind === OwedKind.BillToRequest && item.token) return {type: 'link', to: `/meets/billing/${item.token}`};
    return {type: 'link', to: {path: '/your-profile', query: {tab: 'payments'}}};
};
